import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { connect } from "react-redux";
import { SNACK, START_LOADING, STOP_LOADING  } from '../../../../js/constants/action-types';
import { ALERT_ERROR, ALERT_SUCCESS } from '../../../../js/constants/alert-types';
import { Box, Grid, Typography, Accordion, AccordionSummary, AccordionDetails, TextField, CircularProgress } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import TopPanel from '../../../layouts/TopPanel/TopPanel';
import colors from '../../../../config/theme/colors';
import { eventService } from '../../../../js/services/event.service';
import Button from '../../../ui/button/Button';
import { withApollo } from 'react-apollo';
import PageLoader from "../../../ui/loadings/page-loader/PageLoader";
import CardMerchandisingMain from '../../../layouts/Card/cardContent/CardMerchandisingMain';
import CardCustom from '../../../layouts/Card/CardCustom';
import styled from 'styled-components';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import StatusInfo from '../../../ui/status-info/StatusInfo';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { GET_PRODUCTS_SEARCH_PAGINATION, GET_PRODUCTS_SEARCH_PAGINATION_LIGHT } from '../../../../queries/products';
import CloseIcon from '@material-ui/icons/Close';
import { getTraductionAttributs } from '../../../../js/utils/functions';
import NoImage from '../../../../assets/images/not-found.png';
import { ROUTE_PRODUCTS_COVER_RATE_DETAIL, ROUTE_PRODUCTS_LIST_DETAIL } from '../../../../js/constants/route-names';
import request from '../../../../js/utils/fetch';
import AccordionCustom from '../../../layouts/Accordion/AccordionCustom';
import ListingProducts from './components/ListingProducts';
import { getItemsLocalStorage } from '../../../../js/helpers/filters';
import CardProduct from '../../../layouts/Card/cardContent/CardProduct';
import UpdateIcon from '@material-ui/icons/Update';

const TextFieldCustom = styled(TextField)`
    &:hover{
        fieldset{
            border-color: rgba(0, 0, 0, 0.23);
        }
    }
    input, .MuiSelect-select{
        font-size: 14px;
        padding: 13px;
        padding-right: 120px;
    }
    & > p{
        margin: 0;
    }
`;

// const ContainerButton = styled(Box)`
//     display: flex;
//     justify-content: flex-end;

// `

const InfoStock = styled(Grid)`
    position: absolute;
    top: -32px;
    right: -32px;
    width: 70px;
    height: 70px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    color: white;
    background: ${colors.black.regular};
    opacity: 0.8;
    font-weight: bold;
    line-height: normal;
`
const WrapperAttr = styled(Grid)`
    max-width: 200px;
    p{
        font-size: 13px;
        text-align: left;
        color: ${colors.black.regular};
    }
`
const WrapperImage = styled(Grid)`
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
`
const ContainerCard = styled(Box)`
    display: block;
    position: relative;
    height: auto;
    width: 100%;
    cursor: pointer;
    &:hover{
        &> div{
            opacity: 1;
            button{
                top: 0px;
            }
        }
    }
`
const ButtonCustom = styled(Button)`
    margin: 0;
    text-transform: unset;
    font-weight: bold;
`
const Title = styled(Typography)`
    font-weight: bold;
    overflow: hidden;
    display: -webkit-box;
    height: ${props => props.nbline ? 26 * props.nbline + 'px' : '52px'};
    -webkit-line-clamp: ${props => props.nbline ? props.nbline : '2'};
    -webkit-box-orient: vertical;
`
const Sku = styled(Typography)`
    font-weight: bold;
    color: ${colors.black.regular};
    font-size: 12px;
`;
const ProductAttr = styled.div``;
const SpanColor = styled.span`
    color: ${colors.blue.darker.hue300};
    font-weight: bold;
    font-size: 13px;
`
const ContainerButton = styled(Box)`
    display: flex;
    justify-content: flex-end;
    position: absolute;
    left: -16px;
    top: -16px;
    right: 0;
    width: calc(100% + 32px);
    height: calc(100% + 32px);
    background: rgba(2, 115, 165, 0.3);
    opacity: 0;
    transition: all 0.5s;
    cursor: pointer;
    & > button{
        max-width: 235px;
        top: 20px;
        transition: all 0.8s;
    }
`

const BoxCustom = styled(Box)`
    color: ${props => props.statuscolor};
    svg circle{
        stroke: ${props => props.statuscolor};
    }
    div:nth-child(2) svg circle{
        stroke: #EDEEEE;
    }
    p{
        color: ${props => props.statuscolor};
    }
`;
const CircularProgressCustom = styled(CircularProgress)`
    color: ${props => props.value > 30 
            ? props.value > 65 
                ? colors.green.regular : "#f6d607"
            : colors.red.regular};
    margin-left: ${props => props.marginleft};
`

let timer = null;

function ProductsCoverRate(props) {
    const [currentLang, setCurrentLang] =  React.useState(props.locales[0].node.code);
    const [loading, setLoading] =  React.useState(false);
    const [search, setSearch] =  React.useState("");
    const [productsCover, setProductsCover] =  React.useState([]);
    const [noResult, setNoResult] =  React.useState(false);

    const goTo = route => {
        props.history.push(route);
    };

    const handleLang = (event) => {
        setCurrentLang(event.target.value)
        eventService.fire();
    };

    const handleGetProducts = () => {
        setLoading(true)
        const getProducts = GET_PRODUCTS_SEARCH_PAGINATION_LIGHT;
        let productsDataFilters = [];
        let variables = 
        {
            "itemsPerPage": 9, 
            "page": 1,
        };
        variables.sku = search
        productsDataFilters.push(JSON.stringify({
            'identifier': 'product_name',
            'value': search,
            'locale': currentLang,
            'option': null
        }))
        props.client.query({
            query: getProducts,
            variables,
            fetchPolicy: 'no-cache'
        }).then(async result =>{
            let getProductsCover = result.data.researchProducts.edges
            let formData = new FormData();
            for (let product of getProductsCover){
                formData.append('skus[]', product.node.sku)
            }
            await request(`${process.env.REACT_APP_API}/products/coverage`, 'POST', formData, 'multipart/form-data').then(
                (data) => {
                    Object.keys(data).map((keyName,i) => {
                        getProductsCover.find(e => e.node.sku === keyName).moreInfos = data[keyName]
                    })
                }
            );
            if (getProductsCover.length === 0){
                setNoResult(true)
            }
            setProductsCover(getProductsCover)
            setLoading(false)
        })
    }

    const handleKeyPress = (event) => {
		if (event.key === 'Enter')
            handleGetProducts();
	};

    useEffect(() => {
		document.addEventListener("keydown", handleKeyPress, false);

		return () => document.removeEventListener("keydown", handleKeyPress, false);
	}, [search]);

    return (
        <div>
            <TopPanel
                icomoon         = {"ico-cover-rate"} 
                colorIcomoon    = {colors.blue.darker.hue300}
                title           = {props.t("spread.cover_rate.title")}
                subtitle        = {props.t("spread.cover_rate.subtitle")}
                gradientColor1  = {colors.menu.regular} 
                gradientColor2  = {colors.menu.darker} 
                // openForm        = {openForm}
                currentLang     = {currentLang} 
                handleLang      = {handleLang} 
                locales         = {props.locales}
                // handlerAdd      = {()=> initForm()} 
                // textAdd         = {props.t("spread.merchandising.textAdd")}
                hasBorder={true}
            />
                <Grid container>
                    <AccordionCustom defaultExpanded={true} title={props.t('products.list.filter.searchCover')}>
                    <Typography variant={"body2"} style={{fontSize: 14, marginBottom: 8, color: colors.black.regular}}>{props.t('products.cover_rate.search')}</Typography>
                        <Grid container justifyContent="center" alignItems="center" style={{position:"relative"}}>
                            <Grid item xs={10}>
                                <TextFieldCustom
                                    id={"search-input"}
                                    variant="outlined"
                                    value={search}
                                    onChange={evt => {
                                        setSearch(evt.target.value);
                                    }}
                                    name={"search-input"}
                                    type={"text"}
                                    placeholder={"Recherche"}
                                    style={{width: '100%'}}
                                />
                                {
                                    search && search !== '' ?
                                        <Box style={{cursor:"pointer",position: "absolute", right: 20, top: "50%", transform:"translateY(-50%)", display:"flex", flexDirection:"row", alignItems:"center"}} onClick={() => setSearch('')}>
                                            <CloseIcon style={{fill: "#E01B22"}}/>
                                            <Typography variant='body2' style={{fontWeight: "bold", color: "#E01B22", lineHeight: "24px"}}>Supprimer</Typography>
                                        </Box>
                                    : null
                                }
                            </Grid>
                            <Grid item xs={2}>
                                <Box style={{display:"flex", flexDirection:"row", alignItems:"center"}}>
                                    <Button disabled={search && search !== '' ? false : true} style={{width: "100%", margin: 0 , marginLeft: 16, padding: "14px 32px"}} onClick={() => handleGetProducts()}>Rechercher</Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </AccordionCustom>
                    {
                        !loading ?
                            noResult ?
                                <Typography>Pas de résultats</Typography>
                            :
                                <Grid container spacing={3} style={{margin: 0, marginTop: 8}}>
                                    {productsCover.map((product, index) => (
                                        <Grid item lg={4} md={6} sm={6} xs={6}>
                                            <CardCustom style={{width: "100%", height: "100%",  padding: "16px"}} cardContentStyle={{height: "100%"}} contentpadding={'0'} hovercard={false} collapse={true}>
                                                <CardProduct
                                                    currentLang={currentLang}
                                                    product={product.node}
                                                    locale={props.locales.find(e => e.node.code === props.currentLang)}
                                                    index={index}
                                                    routeProduct={() => goTo(ROUTE_PRODUCTS_COVER_RATE_DETAIL.replace(':sku', product.node.sku))}
                                                    windowWidth={props.windowWidth}
                                                    inForm={true}
                                                />
                                            </CardCustom>
                                        </Grid>
                                    ))}
                                </Grid>
                        : <PageLoader />
                    }
                </Grid>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        loading: state.loading,
        locales: state.locales
    };
};

const mapDispatchToProps = dispatch => {
    return {
        snack: (type, message) => dispatch({ type: SNACK, payload: { type, message }}),
        startLoading: () => dispatch({ type: START_LOADING }),
        stopLoading: () => dispatch({ type: STOP_LOADING })
    }
};

export default withTranslation()(withApollo(withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductsCoverRate))));